var render, staticRenderFns
import script from "./fee_rule.vue?vue&type=script&lang=js&"
export * from "./fee_rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f56e56d0')) {
      api.createRecord('f56e56d0', component.options)
    } else {
      api.reload('f56e56d0', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/fee_rule/fee_rule.vue"
export default component.exports